import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { Main } from '../../components'
import UserHeader from './components/UserHeader'
import { usePageInfo } from '../../config/queries'

const UserDashboard = ({ children }: PropsWithChildren) => {
  const {
    data: { user },
  } = usePageInfo()

  if (user) {
    return (
      <Main title='Profile'>
        <UserHeader />

        <div className='my-6'>{children}</div>
      </Main>
    )
  } else {
    return <Navigate to='/' />
  }
}

export default UserDashboard
